module.exports = __webpack_public_path__ + "img/neotag_unit_red-01.a8ad1405.svg";